import type { DanceSeoHead } from "../danceSeoTypes.js";

// es translation of the English source (shared/danceSeoHeads/en.ts); numbers must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Generador de videos de baile con IA a partir de música",
    description:
      "Convierte cualquier canción en un video de baile con IA. Solmi planifica la coreografía de cada sección y renderiza baile y lip-sync. Gratis para empezar.",
    h1: "Generador de videos de baile con IA: convierte cualquier canción en un video de baile",
  },
  photo: {
    title: "Hacer bailar una foto con IA: pon tu foto a bailar | Solmi",
    description:
      "Haz bailar una foto con IA: sube una foto de cuerpo entero, elige un paso o sube tu clip y añade una canción. Solmi lo ajusta al ritmo. Gratis para empezar.",
    h1: "Haz bailar una foto: generador de baile con IA a partir de una foto",
  },
  inbound:
    "¿Quieres que el artista baile? El [generador de videos de baile con IA](/ai-dance-video-generator) planifica la coreografía de cada sección de tu canción y renderiza un video de baile completo.",
};

export default head;
